// committee type
export const committeTypListApi = 'configuration/committee-types/list'
export const committeTypStoreApi = 'configuration/committee-types/store'
export const committeTypUpdateApi = 'configuration/committee-types/update'
export const committeTypToggleStatusApi = 'configuration/committee-types/toggle-status'

// food list
export const foodlistListApi = 'configuration/food-list/list'
export const foodlistStoreApi = 'configuration/food-list/store'
export const foodlistUpdateApi = 'configuration/food-list/update'
export const foodlistToggleStatusApi = 'configuration/food-list/toggle-status'

// rehabilitation-type
export const rehabilitationTypListApi = 'configuration/rehabilitation-type/list'
export const rehabilitationTypStoreApi = 'configuration/rehabilitation-type/store'
export const rehabilitationTypUpdateApi = 'configuration/rehabilitation-type/update'
export const rehabilitationToggleStatusApi = 'configuration/rehabilitation-type/toggle-status'

// case-type
export const caseTypeListApi = 'configuration/case-type/list'
export const caseTypeStoreApi = 'configuration/case-type/store'
export const caseTypeUpdateApi = 'configuration/case-type/update'
export const caseTypeToggleStatusApi = 'configuration/case-type/toggle-status'

// evaluation setting
export const evaluationSettingListApi = 'configuration/evaluation-setting/list'
export const evaluationSettingStoreApi = 'configuration/evaluation-setting/store'
export const evaluationSettingUpdateApi = 'configuration/evaluation-setting/update'
export const evaluationSettingToggleStatusApi = 'configuration/evaluation-setting/toggle-status'
// committee name
export const committeNameListApi = 'configuration/committee-name/list'
export const committeNameStoreApi = 'configuration/committee-name/store'
export const committeNameUpdateApi = 'configuration/committee-name/update'
export const committeNameToggleStatusApi = 'configuration/committee-name/toggle-status'
// committee-designations
export const committeDesigListApi = 'configuration/committee-designations/list'
export const committeDesigStoreApi = 'configuration/committee-designations/store'
export const committeDesigUpdateApi = 'configuration/committee-designations/update'
export const committeDesigToggleStatusApi = 'configuration/committee-designations/toggle-status'

// e-checklist
export const eCheckListApi = 'configuration/e-checklist/list'
export const eChecklistStoreApi = 'configuration/e-checklist/store'
export const eChecklistUpdateApi = 'configuration/e-checklist/update'
export const eChecklistToggleStatusApi = 'configuration/e-checklist/toggle-status'
export const checklistParamData = 'configuration/e-checklist/checklist-data'
export const fiscalYearData = 'master-fiscal-year/show'

// Institute Type
// export const instituteTypeListApi = 'configuration/institute-type/list'
// export const instituteTypeListStoreApi = 'configuration/institute-type/store'
// export const instituteTypeListUpdateApi = 'configuration/institute-type/update'
// export const instituteTypeListToggleStatusApi = 'configuration/institute-type/toggle-status'

// Add Class
export const AddClassBase = 'configuration/add-class'
export const addClassList = AddClassBase + '/list'
export const addClassStore = AddClassBase + '/store'
export const addClassShow = AddClassBase + '/show'
export const addClassUpdate = AddClassBase + '/update'
export const addClassStatus = AddClassBase + '/toggle-status'
export const addClassDestroy = AddClassBase + '/destroy'

// Exam Type
export const ExamTypeBase = 'configuration/exam-type'
export const examTypeList = ExamTypeBase + '/list'
export const examTypeStore = ExamTypeBase + '/store'
export const examTypeShow = ExamTypeBase + '/show'
export const examTypeUpdate = ExamTypeBase + '/update'
export const examTypeStatus = ExamTypeBase + '/toggle-status'
export const examTypeDestroy = ExamTypeBase + '/destroy'

// Institute Name
// export const instituteNameListApi = '/configuration/institute-name/list'
// export const instituteNameListStoreApi = '/configuration/institute-name/store'
// export const instituteNameListUpdateApi = '/configuration/institute-name/update'
// export const instituteNameListToggleStatusApi = '/configuration/institute-name/toggle-status'

// course information
export const courseInfoListApi = 'configuration/course-information/list'
export const courseInfoStoreApi = 'configuration/course-information/store'
export const courseInfoUpdateApi = 'configuration/course-information/update'
export const courseInfoToggleStatusApi = 'configuration/course-information/toggle-status'
export const courseInfoParamData = 'configuration/course-information/course-info-data'

// institutional-school-name
export const schoolNameListApi = 'configuration/institutional-school-name/list'
export const schoolNameStoreApi = 'configuration/institutional-school-name/store'
export const schoolNameUpdateApi = 'configuration/institutional-school-name/update'
export const schoolNameToggleStatusApi = 'configuration/institutional-school-name/toggle-status'
export const schoolNameParamData = 'configuration/institutional-school-name/course-info-data'

// Report Heading
export const reportHeadingList = 'configuration/report-heading/list'
export const reportHeadingStore = 'configuration/report-heading/store'
export const reportHeadingUpdate = 'configuration/report-heading/update'
export const reportHeadingDetail = 'configuration/report-heading/detail'
export const reportToggleStatus = 'configuration/report-heading/toggle-status'

// notification routes
export const notificationReceivedList = '/notification-received/list'
